<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header">
                        <div class="d-md-flex align-items-center">
                            <div>
                                <h4 class="card-title">All Bills</h4>
                                <h6 class="card-subtitle">Search bills by status, customer</h6>
                            </div>
                            <div class="ml-auto d-flex no-block align-items-center">
                                <div class="dl">
                                    <div class="button-group">
                                        <router-link :to="{name: 'addexpressbill', params: {expressid: currentOrg.express_id}}" class="btn btn-success waves-effect waves-light">
                                            <i class="fas fa-plus"></i> New Bill
                                        </router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-body" v-if="bills.length>0">
                        <form>
                            <div class="form-row">
                                <div class="form-group col-md-4">
                                    <multiselect
                                            :class="{'is-invalid': submitted && errors.has('partner')}"
                                            :clear-on-select="false"
                                            :close-on-select="true"
                                            :hide-selected="true"
                                            :internal-search="false"
                                            :limit="3"
                                            :loading="isLoading"
                                            :max-height="600"
                                            :options="buyers"
                                            :options-limit="300"
                                            :searchable="true"
                                            :show-no-results="false"
                                            @input="selectBuyer()"
                                            @search-change="searchBuyers"
                                            class="form-control"
                                            data-vv-as="buyer"
                                            id="buyer"
                                            label="buyer"
                                            name="buyer"
                                            open-direction="bottom"
                                            placeholder="Search Buyer"
                                            track-by="id"
                                            v-model="buyer"
                                            v-validate="'required'">
                                        <template slot="singleLabel" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc">
                                                    {{ props.option.biz_name }}
                                                </div>
                                            </div>
                                        </template>
                                        <template slot="option" slot-scope="props">
                                            <div class="option__desc">
                                                <div class="option__desc" v-if="props.option">
                                                    <h5>{{ props.option.biz_name }}</h5>
                                                    <h6>{{ props.option.line1}}</h6>
                                                    <h6>{{ props.option.city+', '+ props.option.country}}</h6>
                                                </div>
                                                <div class="option__desc" v-else>
                                                    <h5>Add New</h5>
                                                </div>
                                            </div>
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="form-group col-md-2">
                                    <select class="custom-select" id="inlineFormCustomSelect" style="height: 42px;" v-model="filter.status">
                                        <option value="">Choose Status</option>
                                        <option
                                                v-bind:key="index"
                                                v-bind:value="s"
                                                v-for="(s, index) in statuses">{{s | capitalize}}
                                        </option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <input
                                            class="form-control"
                                            name="purchase"
                                            placeholder="Bill #"
                                            style="height: 42px;"
                                            type="text"
                                            v-model="filter.billid">
                                </div>
                                <div class="form-group col-md-4">
                                    <div class="input-group mb-2" id="drp">
                                        <v-md-date-range-picker
                                                :auto-apply="false"
                                                :end-date="endDate"
                                                :opens="opens"
                                                :show-activator-bar="false"
                                                :show-activator-label="false"
                                                :show-custom-range-label="value"
                                                :start-date="startDate"
                                                @change="change"
                                                show-year-select>
                                        </v-md-date-range-picker>
                                        <div class="input-group-append">
                                            <button @click="searchBills(1)" class="btn btn-light btn-outline-success custom-go" type="button">Go!</button>
                                            <button @click="reset()" class="btn btn-light btn-outline-secondary btn-arrange" style="height: 42px;" type="button">Reset!</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>

                        <div class="table-responsive m-t-30">
                            <div class="col-md-12">
                                <div class="form-group row">
                                    <label class="col-form-label" for="records" style="padding-left: 10px;">Display Maximum</label>
                                    <div class="col-sm-2" style="padding-top: 5px;">
                                        <select @change="perPageRecordChange()" aria-controls="lang_opt" class="form-control form-control-sm" id="records" name="lang_opt_length" v-model="perPage">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                    <label class="col-form-label" for="records">Records per page</label>
                                </div>
                            </div>
                            <table class="table no-wrap v-middle">
                                <thead>
                                <tr class="border-0">
                                    <th class="border-0" style="width: 0px;">
                                        <div class="form-check">
                                            <input
                                                    @change="checkAll($event)"
                                                    class="form-check-input"
                                                    id="checkAll"
                                                    type="checkbox">
                                            <label class="form-check-label" for="checkAll"></label>
                                        </div>
                                    </th>
                                    <th class="border-0"><h6>#</h6></th>
                                    <th class="border-0"><h6>Status</h6></th>
                                    <!--                                    <th class="border-0"><h6>Number</h6></th>-->
                                    <th class="border-0"><h6>Buyer</h6></th>
                                    <th class="border-0"><h6>Goods/Services</h6></th>
                                    <th class="border-0"><h6>Total</h6></th>
                                    <th class="border-0"><h6>Due At</h6></th>
                                    <th class="border-0"><h6>Actions</h6></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-bind:key="index" v-for="(bill, index) in bills">
                                    <td class="sorting_1">
                                        <div class="form-check">
                                            <input
                                                    class="form-check-input"
                                                    type="checkbox"
                                                    v-bind:id="bill.id"
                                                    v-bind:value="bill"
                                                    v-model="checkedBills">
                                            <label class="form-check-label" v-bind:for="bill.id"></label>
                                        </div>
                                    </td>
                                    <td>{{index+1}}</td>
                                    <td>
                                        <p v-if="bill.status === 'UNPAID'"><span class="label label-cyan">Unpaid</span></p>
                                        <p v-if="bill.status === 'PAID'"><span class="label label-dark-green">Paid</span></p>
                                    </td>
                                    <!--                                    <td>{{bill.invoice_number}}</td>-->
                                    <td>{{bill.partner.biz_name | capitalize}}</td>
                                    <td>
                                        <ul>
                                            <li v-bind:key="index" v-for="(item, index) in bill.bill_items">
                                                {{item.goods_services}}
                                            </li>
                                        </ul>
                                    </td>
                                    <td>{{bill.total | money}}</td>
                                    <td>{{bill.due_at | medium}}</td>
                                    <td>
                                        <router-link :to="{'name': 'viewexpressbill', 'params': {billid: bill.id}}"><h6>View</h6></router-link>
                                    </td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="hide" id="invoice-summary-table">
                                <table class="table table-bordered">
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Invoice Id</th>
                                        <th>Partner</th>
                                        <th>Status</th>
                                        <th>Price</th>
                                        <th>Created at</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="card-body card-blue" v-else>
                        <h4 class="card-title text-muted text-center">No records found</h4>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <paginate
                        :click-handler="pageHandler"
                        :container-class="'pagination float-right'"
                        :margin-pages="2"
                        :next-class="'page-link'"
                        :next-text="'Next'"
                        :page-class="'page-link'"
                        :page-count=pageCount
                        :page-range="3"
                        :prev-class="'page-link'"
                        :prev-text="'Prev'">
                </paginate>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import Blockie from "../../common/Blockie";
    import Paginate from 'vuejs-paginate';
    import Multiselect from 'vue-multiselect';
    import moment from 'moment';
    import _ from 'lodash';
    import JsonCSV from 'vue-json-csv';

    export default {
        name: "Bills",
        computed: {
            ...mapGetters(["currentUser", "currentOrg"])
        },
        components: {Blockie, Multiselect, Paginate, JsonCSV},
        data() {
            return {
                submitted: false,
                isLoading: false,
                statuses: ['UNPAID', 'PAID'],
                buyers: [],
                filter: {
                    buyer_id: null,
                    status: "",
                    fromDate: "",
                    toDate: "",
                    billid: ""
                },
                buyer: null,
                startDate: moment(new Date()).format('YYYY-MM-DD'),
                endDate: moment(new Date()).format('YYYY-MM-DD'),
                bills: [],
                pageCount: 1,
                total: 0,
                opens: 'right',
                value: true,
                checkedBills: [],
                exportedBills: [],
                inv_export_name: "Invoice_Report.csv",
                perPage: 10,
                isFiltered: false
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            async init() {
                await this.getBills();
            },
            perPageRecordChange() {
                if(this.isFiltered) {
                    this.searchBills(1);
                } else {
                    this.getBills(1);
                }
            },
            async getBills(page) {
                try {
                    $(".preloader").fadeIn();
                    let reply = await this.$http.get(`/express/${this.currentOrg.express_id}/bills`, {
                        params: {
                            page: page,
                            perPage: this.perPage
                        }
                    });
                    $(".preloader").fadeOut();

                    this.isFiltered = false;
                    this.total      = reply.data.total;
                    this.bills      = reply.data.bills;
                    let max_date    = reply.data.min_date;
                    let min_date    = reply.data.max_date;
                    if(min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate   = moment(min_date).format('YYYY-MM-DD');
                    } else if(this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate   = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate   = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.setPageCount();
                } catch(e) {
                    $(".preloader").fadeOut();
                }
            },
            pageHandler(pageNum) {
                this.getBills(pageNum);
            },
            setPageCount() {
                this.pageCount = this.total <= this.perPage ? 1 : Math.ceil(this.total / this.perPage);
            },
            checkAll(e) {
                if(e.target.checked) {
                    this.checkedBills = this.invoices
                } else {
                    this.checkedBills = []
                }
            },
            change(e) {
                this.filter.fromDate = e[0].toDate();
                this.filter.toDate   = e[1].toDate();
            },
            async searchBuyers(searchText) {
                try {
                    this.isLoading = true;
                    let reply      = await this.$http.get("/express/" + this.currentOrg.express_id + "/partner/search", {
                        params: {
                            search: searchText
                        }
                    });
                    this.buyers    = reply.data;
                    this.isLoading = false;
                } catch(e) {
                    console.log(err);
                }
            },
            selectBuyer() {
                this.filter.buyer_id = this.buyer.id;
            },
            async searchBills(page) {
                try {
                    let reply    = await this.$http
                    .get(`/express/${this.currentOrg.express_id}/invoices/${JSON.stringify(this.filter)}/search`, {
                        params: {
                            page: page,
                            perPage: this.perPage
                        }
                    });
                    this.total   = reply.data.total;
                    this.bills   = reply.data.bills;
                    let max_date = reply.data.min_date;
                    let min_date = reply.data.max_date;
                    if(min_date && max_date) {
                        this.startDate = moment(max_date).format('YYYY-MM-DD');
                        this.endDate   = moment(min_date).format('YYYY-MM-DD');
                    } else if(this.bills.length === 1) {
                        this.startDate = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                        this.endDate   = moment(this.bills[0].created_at).format('YYYY-MM-DD');
                    } else {
                        this.startDate = moment(new Date()).format('YYYY-MM-DD');
                        this.endDate   = moment(new Date()).format('YYYY-MM-DD');
                    }
                    this.isFiltered = true;
                    this.setPageCount();
                } catch(e) {
                    console.log(e);
                }
            },
        }
    }
</script>

<style scoped>

</style>
